import React from 'react';
import styled, { keyframes } from 'styled-components';
import cn from 'classnames';

interface Props {
  size?: number;
  className?: string;
}

export const Spinner = (props: Props) => {
  const { size = 30, className = '' } = props;
  return (
    <Throbber $size={size} className={cn('lt-preloader-throbber', className)} />
  );
};

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  from {
    transform: rotate(360deg);
  }
`;

const Throbber = styled.div<{ $size: number }>`
  position: relative;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    content: '';
    border-width: 2px;
    border-style: solid;
    border-color: #444;
    border-right-color: #efefef;
    border-bottom-color: #efefef;
    border-radius: 100%;
    animation: ${spin} 1s linear infinite;
  }
`;
